import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import {
    createColorStyles,
    getJobCompensationInfo,
} from '../common/utilities';

export class JobItem extends Component {
    constructor(props) {
        super(props);

        this.state = {
            allowsUp: false,
            allowsDown: false,
        }
    }

    componentDidMount() {
        const { jobs, job, levelIndex, levels } = this.props;
        const id = job.id;

        const maxLevelIndex = levels.length - 1;

        const jobsGrowthLateral = !!(job.job_growth_opportunities && job.job_growth_opportunities.length);

        const jobsDown = jobs
            .filter(jobItem => jobItem.job_growth_opportunities && jobItem.job_growth_opportunities.includes(job.id))
            .map(jobItem => jobItem.id)
            .length

        this.setState({
            // Top most level jobs should only point down (if you hover on the top half of the node, nothing is displayed). Lateral job opps will be part of the down click.
            allowsUp: jobsGrowthLateral,
            allowsDown: jobsDown,
        })
    }

    render() {
        const {
            job,
            levelIndex,
            cat,
            catIndex,
            categories,
            levels,
            position,
            isShowCollegeDegree,
            isShowCompensation,
            isShowRegionalCompensation,
            selectedRegion,
            regions,
            isShowSemiconductorJobs,
            labels,
        } = this.props;
        const { allowsUp, allowsDown } = this.state;

        const classes = classNames(
            `level-${levelIndex + 1}`,
            `cat-${catIndex + 1}`,
            {
                'level-last': levelIndex + 1 === levels.length,
                'level-first': levelIndex + 1 === 1,
                'cat-last': catIndex + 1 === categories.length,
                'semiconductor': isShowSemiconductorJobs && job.is_semiconductor_job,
                'high-demand': job.high_demand_job
            }
        );

        const { isShowCompensationInfo, compensation } = getJobCompensationInfo({
            isShowCompensation,
            isShowRegionalCompensation,
            job,
            selectedRegion,
            regions,
        });

        return (
            <div
                className={`job position-${position} ${classes}`}
                data-id={job.id}
                style={createColorStyles(cat)}
                data-level-index={levelIndex}
            >
                <div className="front">
                    <div className="dot">
                        { job.is_union_job && <div className="special union" />}
                        { isShowCollegeDegree && job.requires_college_degree && !job.is_union_job && <div className="special diamond" />}

                        <div className="arrows">
                            {
                                allowsUp ? (
                                    <div
                                        className="direction growth"
                                        data-direction="growth-lateral"
                                    >
                                        <div className="arrow central" />
                                        <div className="arrow aside left" />
                                        <div className="arrow aside right" />
                                    </div>
                                ) : null
                            }

                            {
                                allowsDown ? (
                                    <div
                                        className="direction down"
                                        data-direction="down"
                                    >
                                        <div className="arrow central" />
                                        <div className="arrow aside left" />
                                        <div className="arrow aside right" />
                                    </div>
                                ) : null
                            }

                            <div className="direction middle" data-direction="middle" />
                        </div>
                    </div>
                    <div className="title">{job.name}</div>
                </div>

                <div className="description">
                    <div className="description-inner">
                        <button className="description-close"><span className="show-for-sr">Close</span></button>
                        <div className="description-title">{job.name}</div>
                        {
                            isShowCollegeDegree && job.requires_college_degree
                                ? <div className="special diamond"><span>{labels?.college_degree_required || 'College Degree Required'}</span></div>
                                : null
                        }

                        {isShowCompensationInfo && (
                            <>
                                {compensation.salary && compensation.salary.low_end && compensation.salary.high_end ? (
                                    <div className="price annual">
                                        {compensation.salary.low_end} - {compensation.salary.high_end} / {labels?.salary_year || 'year'}
                                    </div>
                                ) : null}

                                {compensation.hourly && compensation.hourly.low_end && compensation.hourly.high_end ? (
                                    <div className="price hour">
                                        {compensation.hourly.low_end} - {compensation.hourly.high_end} / {labels?.salary_hour || 'hour'}
                                    </div>
                                ) : null}

                                {compensation.grade ? (
                                    <div className="price grade">
                                        {compensation.grade}
                                    </div>
                                ) : null}
                            </>
                        )}

                        <a href={`#modal-${job.id}`} className="button js-modal">{labels?.job_details_btn || 'Details'}</a>
                    </div>
                </div>

            </div>
        );
    }
}

JobItem.propTypes = {
    job: PropTypes.object.isRequired,
    isShowCollegeDegree: PropTypes.bool.isRequired,
    position: PropTypes.number.isRequired,
    cat: PropTypes.object.isRequired,
    categories: PropTypes.array.isRequired,
    levels: PropTypes.array.isRequired,
    levelIndex: PropTypes.number.isRequired,
    catIndex: PropTypes.number.isRequired,
}
